import { useHistory, useLocation } from "react-router-dom";
import { isArray } from "chart.js/helpers";

import filterDuplicateItems from "../libs/filterDuplicateItems";
import { useState } from "react";

export const EQUAL_SIGN = "=";
export const AND_SIGN = "&";
export const ARRAY_SEPARATOR = ",";

function parseUrl(url) {
  return url
    ?.replace("?", "")
    ?.split(AND_SIGN)
    ?.filter((v) => v)
    ?.reduce((acc, cur) => {
      const [key, value] = cur.split(EQUAL_SIGN);
      return {
        ...acc,
        [key]: decodeURIComponent(value),
      };
    }, {});
}

function parseUrlForFilterState(url) {
  return url
    ?.replace("?", "")
    ?.split(AND_SIGN)
    ?.filter((v) => v)
    ?.reduce((acc, cur) => {
      const [key, value] = cur.split(EQUAL_SIGN);
      let object = {};
      let itemsArray = decodeURIComponent(value).split(ARRAY_SEPARATOR);
      for (let key in itemsArray) {
        let itemInArray = itemsArray[key];
        object[itemInArray] = itemInArray;
      }
      if (key === "page") {
        return {
          ...acc,
          [key]: parseInt(itemsArray[0]),
        };
      }
      if (key === "tab") {
        return {
          ...acc,
          [key]: itemsArray[0],
        };
      }

      return {
        ...acc,
        [key]: object,
      };
    }, {});
}

function stringifyUrl(data) {
  if (data) {
    return Object.entries(data)
      ?.filter(([k, v]) => k && v)
      ?.reduce((acc, [key, val], idx) => {
        return `${acc}${idx === 0 ? "" : AND_SIGN}${key}${EQUAL_SIGN}${val}`;
      }, "?");
  }
}

function useFilter(defaultFilters) {
  const location = useLocation();
  const history = useHistory();
  const filterState = parseUrlForFilterState(location.search);
  const [selectFilters, setSelectFilter] = useState(defaultFilters);

  function onChange(name, value) {
    let existItemArray = parseUrl(location.search);
    if (isArray(value)) {
      if (name !== "page") delete existItemArray.page;
      existItemArray[name] = value.reduce((output, item, index) => {
        if (value.length > 1 && index > 0)
          return (output += `,${item.value || item.id}`);
        return (output += item.value || item.id);
      }, "");
      existItemArray[name] = [
        ...new Set(existItemArray[name]?.split(",")),
      ].toString();
    } else {
      existItemArray[name] = value;
    }

    const result = stringifyUrl(existItemArray);
    history.replace(`${result}`);
  }

  function onFilterChange(selectedOptions, paramName, actionMeta, singleOption) {
    if (actionMeta.action === "clear") {
      onChange(paramName, []);
      return setSelectFilter({
        ...selectFilters,
        [actionMeta.name]: [],
      });
    }
    let selectedItems = [...selectFilters[actionMeta.name]];
    const selectedOption =
      actionMeta.option || actionMeta.removedValue || singleOption;
    if (selectedOption.child !== undefined) {
      if (selectedItems.length > 0) {
        const parentLess = selectedItems.filter(
          (item) => item.value !== selectedOption.value
        );
        if (selectedItems.length !== parentLess.length) {
          const filteredList = parentLess.filter((item) =>
            typeof item.value === "string"
              ? true
              : !(
                  item.value >= selectedOption.child[0].value &&
                  item.value <=
                    selectedOption.child[selectedOption.child.length - 1].value
                )
          );
          setSelectFilter({
            ...selectFilters,
            [actionMeta.name]: filterDuplicateItems(filteredList),
          });
          return onChange(paramName, filterDuplicateItems(filteredList));
        }
      }
      selectedItems.push(...selectedOption.child, selectedOption);
      setSelectFilter({
        ...selectFilters,
        [actionMeta.name]: filterDuplicateItems(selectedItems),
      });
      return onChange(paramName, filterDuplicateItems(selectedItems));
    }
    if (selectedItems.length > 0) {
      const childExecit = selectedItems.find(
        (item) => item.value === selectedOption.value
      );
      if (childExecit != undefined) {
        const parentLess = selectedItems.filter(
          (item) => item.value !== selectedOption.parentValue
        );
        const filteredList = parentLess.filter((item) =>
          typeof item.value === "string"
            ? true
            : !(item.value === selectedOption.value)
        );
        setSelectFilter({
          ...selectFilters,
          [actionMeta.name]: filterDuplicateItems(filteredList),
        });
        return onChange(paramName, filterDuplicateItems(filteredList));
      }
    }
    selectedItems.push(selectedOption);
    setSelectFilter({ ...selectFilters, [actionMeta.name]: selectedItems });
    onChange(paramName, filterDuplicateItems(selectedItems));
  }

  function onClearAll() {
    history.replace(location.pathname);
  }

  return {
    filterState,
    onChange,
    onFilterChange,
    selectFilters,
    setSelectFilter,
    onClearAll,
  };
}

export default useFilter;
